import { render, staticRenderFns } from "./conceptgroups-grid.vue?vue&type=template&id=ec291088&scoped=true&"
import script from "./conceptgroups-grid.ts?vue&type=script&lang=ts&"
export * from "./conceptgroups-grid.ts?vue&type=script&lang=ts&"
import style0 from "./conceptgroups-grid.scss?vue&type=style&index=0&id=ec291088&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec291088",
  null
  
)

export default component.exports